import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#D1D8E0",
          fontFamily: "Poppins, sans-serif",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#2E4053",
          }}
        >
          ✅ Payment Successful!
        </Typography>
        <Typography
          variant="h6"
          sx={{
            marginBottom: "36px",
            color: "#34495E",
            lineHeight: 1.5,
            fontWeight: 400,
            maxWidth: "500px",
          }}
        >
          Thank you for your purchase. Your subscription has been activated.
        </Typography>
        <Button
          variant="contained"
          onClick={handleGoToDashboard}
          sx={{
            backgroundColor: "#2E4053",
            color: "#FFFFFF",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#1C2A3D",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default SuccessPage;
